import React, { useState } from 'react';


export const useImageUpload = () => {
	const [filebase64,setFileBase64] = useState("")
	const [imgErr, setImgErr] = useState()

	const checkImg = (file) => {

		if (!(file[0]?.type.includes("image"))) {
			setImgErr("Please select an Image file to proceed ")

			return
		}

		var reader = new FileReader();
	
		// Read the contents of Image File.
		reader.readAsDataURL(file[0]);
		reader.onload = function (e) {
		  //Initiate the JavaScript Image object.
		  var image = new Image();
	
		  //Set the Base64 string return from FileReader as source.
		  image.src = e.target.result;
	
		  //Validate the File Height and Width.
		  image.onload = function () {
			var height = this.height;
			var width = this.width;
			// console.log(width, height);
			
			if (height != 250 || width != 250) {
			//   alert("Height and Width must be 250px.");
			  return false;
			}
			// alert("Uploaded image has valid Height and Width.");
			return true;
		  };
		};
		return true;
	  };

	const convertFile = async (files) => {

		const imgSizeCheck = await checkImg(files)
   
		// console.log(imgSizeCheck);
		
		   if (imgSizeCheck) {
			//    console.log(files[0]);
			   
			 const fileRef = files[0] || ""
			 const fileType= fileRef.type || ""
		   //   console.log("This file upload is of type:",fileType)
			 const reader = new FileReader()
   
			
			 reader.readAsBinaryString(fileRef)
			 reader.onload=(ev) => {
			   // convert it to base64

			   setFileBase64(`data:${fileType};base64,${btoa(ev.target.result)}`)		   
			 }

			 
		   }

	return true
	}

  return {convertFile, filebase64, setFileBase64, imgErr}
}